import React, { useEffect } from "react";
import { Referances } from "../../assets/img/references";
import Slider from "react-slick";
import Bg1 from "../../assets/img/anasayfa_kucuk_1.jpg";
import Bg2 from "../../assets/img/anasayfa_kucuk_2.jpg";
import CustomerSupport from "../../assets/img/customer-support.png";
import GuaranteeCertificate from "../../assets/img/guarantee-certificate.png";
import CustomerService from "../../assets/img/customer-service.png";
import CreditCard from "../../assets/img/credit-card.png";
import Shipped from "../../assets/img/shipped.png";
import axiosClient from "../../api";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import MobileBanner from "../../assets/img/414-904.jpg";
import MobileBanner2 from "../../assets/img/414-904-2.png";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Brands } from "../../assets/img/brand";
import { toast } from "react-toastify";
import { FaDolly } from "react-icons/fa6";
import { FaMedal, FaTools } from "react-icons/fa";
import { LuChevronsRight } from "react-icons/lu";
import LensaBanner from "../../assets/img/lensa-banner.png";

const settings = {
  dots: false,
  infinite: true,
  speed: 7000,
  slidesToShow: 10,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  initialSlide: 0,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
  ],
};

const settingsSlider = {
  dots: false,
  infinite: true,
  speed: 500, // Geçiş süresi (milisaniye cinsinden)
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false, // Otomatik geçişi kapatıyoruz
  arrows: true,
};

const HomePage = () => {
  const [products, setProducts] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [brands, setBrands] = React.useState([]);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const [checkbox, setCheckbox] = React.useState(false);

  const cardRefs = React.useRef([]);
  const sliderRef = React.useRef(null);

  const validationSchema = Yup.object({
    FirstName: Yup.string().required("Lütfen adınızı giriniz"),
    lastName: Yup.string().required("Soyisim gereklidir"),
    email: Yup.string()
      .email("Geçerli bir email giriniz")
      .required("Lütfen email adresinizi giriniz"),
    PhoneNumber: Yup.string().required("Lütfen telefon numaranızı giriniz"),
    productId: Yup.string().required("Ürün gereklidir"),
    message: Yup.string().required("Mesaj gereklidir"),
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext(); // Bir sonraki slayta geçiş yapar
      }
    }, 10000); // 10 saniye

    // Temizlik fonksiyonu ile interval'ı temizleriz
    return () => clearInterval(intervalId);
  }, []);

  React.useEffect(() => {
    const handleScroll = () => {
      cardRefs.current.forEach((cardRef) => {
        if (isElementInViewport(cardRef)) {
          cardRef.classList.add("card-entered", "left-entered");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll event once on mount
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const filteredResults = (brandID) => {
    const filteredProducts = categories.flatMap((category) => {
      const filteredCategoryProducts = category.product.filter(
        (product) => product.brandID === brandID
      );
      const filteredSubCategoryProducts = category.subCategories.flatMap(
        (subCategory) =>
          subCategory.product.filter((product) => product.brandID === brandID)
      );
      return [...filteredCategoryProducts, ...filteredSubCategoryProducts];
    });
    setProducts(filteredProducts);
  };

  useEffect(() => {
    axiosClient.get("/Category/GetAllCategoryHierarchy").then((res) => {
      setCategories(res.data.categories);
    });
  }, []);

  useEffect(() => {
    axiosClient.get("/Brand").then((res) => {
      setBrands(res.data.brands);
    });
  }, []);

  useEffect(() => {
    filteredResults("69579afb-951d-407f-b22f-2b0c1cfebbd4");
    setSelectedBrand("69579afb-951d-407f-b22f-2b0c1cfebbd4");
  }, [categories]);

  const initialValues = {
    FirstName: "",
    lastName: ".",
    email: "",
    PhoneNumber: "",
    productId: "1a1abdb8-5c6d-4f7e-a220-09004b5a5990",
    message: ".",
  };

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    console.log(values);
    // Handle form submission logic here
    axiosClient
      .post("/Contact", values)
      .then((res) => {
        toast.success("Mesajınız başarıyla gönderildi.");
        resetForm();
      })
      .catch((error) => {
        toast.error("Mesaj gönderilemedi. Lütfen tekrar deneyin.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  console.log(products, "products");
  return (
    <div className="bg-white">
      <Helmet>
        <title>Anasayfa - LENSA</title>
        <meta
          name="description"
          content="Depo Çözümlerinde LENSA Yanınızda! LENSA, depo çözümleri konusunda sizlere en iyi hizmeti sunar."
        />
      </Helmet>
      <div className="h-screen w-full flex items-center justify-center">
        <div className="w-full h-full slick-slider-homepage bg-[#070707]">
          {window.innerWidth > 768 ? (
            <Slider ref={sliderRef} {...settingsSlider}>
              {/**
               * <div className="h-full w-full homepage-slider">
              <ReactPlayer
                url={Slider01}
                playing
                loop
                muted
                width="100%"
                height="100%"
              />
            </div>
               */}
              <div className="h-full w-full homepage-slider">
                <img
                  src={LensaBanner}
                  className="w-full h-[calc(100vh-0px)]"
                  alt="El Terminalleri"
                />
              </div>
            </Slider>
          ) : (
            <Slider {...settingsSlider}>
              <div className="h-full w-full homepage-slider">
                <img
                  src={MobileBanner}
                  className="w-full h-[calc(100vh-0px)] object-contain"
                  alt="El Terminalleri"
                />
              </div>
              <div className="h-full w-full homepage-slider">
                <img
                  src={MobileBanner2}
                  className="w-full h-[calc(100vh-0px)] object-contain"
                  alt="El Terminalleri"
                />
              </div>
            </Slider>
          )}
        </div>
      </div>

      <div
        ref={(el) => (cardRefs.current[1] = el)}
        className="card-container container py-16"
      >
        <Slider {...settings}>
          {Brands.map((item, index) => (
            <div key={index} className="flex justify-center items-center">
              <img src={item} className="w-60" alt="" />
            </div>
          ))}
        </Slider>
      </div>
      <div className="bg-main py-20">
        <div className="px-10">
          <div className="grid grid-cols-4 gap-10 max-md:grid-cols-1">
            <div className="rounded-lg bg-white flex flex-col gap-5 p-5 justify-between">
              <FaDolly className="text-6xl text-main" />
              <p className="font-bold text-3xl">
                Türkiye'nin Önde Gelen <br /> OT/VT Firması
              </p>
              <p className="text-gray-500 text-lg">
                LENSA, barkod teknolojileri, otomatik etiketleme makineleri,
                RFID donanımları ve özel yazılım çözümleri ile müşterilerine
                kesintisiz çözümler sunar. Firmamız tedarik etmiş olduğu tüm
                ürünlere teknik servis, yedek parça ve sarf malzemeleri de
                sağlar.
              </p>
            </div>
            <div className="rounded-lg bg-white flex flex-col gap-5 p-5 justify-between">
              <FaMedal className="text-6xl text-main" />
              <p className="font-bold text-3xl">
                Sürdürülebilir <br /> Başarı
              </p>
              <p className="text-gray-500 text-lg">
                LENSA, bilgi teknolojileri, yazılım ve donanım alanında artan
                tecrübesi ve uzman kadrosuyla emin adımlarla ilerlemektedir.
                Müşteri odaklı hizmet anlayışı ve yenilikçi çözümleriyle
                sektörde sürdürülebilir başarı elde etmektedir.
              </p>
            </div>

            <div className="rounded-lg bg-white flex flex-col gap-5 p-5 justify-between">
              <FaTools className="text-6xl text-main" />
              <p className="font-bold text-3xl">
                Profesyonel Teknik <br /> Destek
              </p>
              <p className="text-gray-500 text-lg">
                LENSA, müşterilerine donanımlı teknik servis ekibiyle satış
                sonrası eğitim ve servis desteği sunar. Barkod teknolojileri,
                otomatik etiketleme makineleri, RFID donanımları ve özel yazılım
                çözümleri konusunda uzmanlaşmıştır.
              </p>
            </div>
            <div
              className="rounded-lg bg-white flex flex-col gap-5 p-5 justify-between"
              ref={(el) => (cardRefs.current[3] = el)}
            >
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ isSubmitting }) => (
                  <Form className="flex flex-col justify-between h-full">
                    <div>
                      <p className="font-bold text-3xl text-main max-md:text-4xl max-md:mb-3">
                        İletişime Geç
                      </p>
                    </div>
                    <div className="flex gap-5 mt-1 max-md:flex-col">
                      <div className="flex-1 flex flex-col">
                        <label
                          className="font-semibold text-xl text-main"
                          htmlFor="FirstName"
                        >
                          Ad Soyad*
                        </label>
                        <Field
                          className="border-b-2 bg-transparent border-b-main focus:outline-none text-md text-main"
                          type="text"
                          id="FirstName"
                          name="FirstName"
                        />
                        <ErrorMessage
                          className="text-red-500"
                          name="FirstName"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="flex gap-5 max-md:flex-col">
                      <div className="flex flex-col mt-5 flex-1">
                        <label
                          className="font-semibold text-xl text-main"
                          htmlFor="email"
                        >
                          Email*
                        </label>
                        <Field
                          className="border-b-2 bg-transparent border-b-main focus:outline-none text-md text-main"
                          type="email"
                          id="email"
                          name="email"
                        />
                        <ErrorMessage
                          className="text-red-500"
                          name="email"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="flex gap-5 max-md:flex-col">
                      <div className="flex flex-col mt-5 flex-1">
                        <label
                          className="font-semibold text-xl text-main"
                          htmlFor="PhoneNumber"
                        >
                          Telefon*
                        </label>
                        <Field
                          className="border-b-2 bg-transparent border-b-main focus:outline-none text-md text-main"
                          type="text"
                          id="PhoneNumber"
                          name="PhoneNumber"
                        />
                        <ErrorMessage
                          className="text-red-500"
                          name="PhoneNumber"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="flex gap-5 mt-2 max-md:flex-col items-center">
                      <label htmlFor="newsletter">
                        <input
                          type="checkbox"
                          id="newsletter"
                          name="newsletter"
                          className="mr-1 !text-lg"
                          checked={checkbox}
                          onChange={(e) => setCheckbox(e.target.checked)}
                          value={checkbox}
                        />
                        <span className="text-sm text-main">
                          Form gönderme koşullarını ve kişisel verilerin
                          kullanılması ve korunması hakkındaki aydınlatma
                          metnini okudum, onaylıyorum.
                        </span>
                        <p className="text-sm text-main mt-3">
                          Yukarıdaki alanlar üzerinden tarafımıza
                          açıklayacağınız kişisel verileriniz LENSA Bilişim
                          Teknolojileri Sanayi ve Ticaret Anonim Şirketi
                          tarafından İletişim Faaliyetlerinin Yürütülmesi, Talep
                          / Şikayetlerin Takibi, İş Süreçlerinin
                          İyileştirilmesine Yönelik Önerilerin Alınması Ve
                          Değerlendirilmesi, Mal / Hizmet Satış Sonrası Destek
                          Hizmetlerinin Yürütülmesi, Müşteri Memnuniyetine
                          Yönelik Aktivitelerin Yürütülmesi, Müşteri İlişkileri
                          Yönetimi Süreçlerinin Yürütülmesi amaçlarıyla
                          işlenecektir. Ayrıntılı bilgiye{" "}
                          <Link
                            className="font-bold"
                            to="/iletisim-formu-aydinlatma-metni"
                          >
                            İletişim Formu Aydınlatma Metni
                          </Link>
                          ’nden ulaşabilirsiniz.”
                        </p>
                      </label>
                    </div>
                    <button
                      type="submit"
                      className="mt-5 bg-main py-2 text-white"
                      disabled={!checkbox}
                    >
                      Gönder
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container card-container py-16 max-md:hidden"
        ref={(el) => (cardRefs.current[4] = el)}
      >
        <div className="flex items-center justify-between mb-10 max-md:flex-col">
          <h2 className="text-4xl">
            <span className="font-bold">POPÜLER</span> MARKALAR
          </h2>
          <ul className="flex items-center gap-10 max-md:mt-5 max-md:flex-col">
            {brands
              ?.filter(
                (brand) =>
                  brand.name === "Argox" ||
                  brand.name === "Point Mobile" ||
                  brand.name === "Sewoo" ||
                  brand.name === "Hanasis"
              )
              .map((category, index) => (
                <li
                  key={index}
                  className={`${
                    selectedBrand === category.id
                      ? "text-main text-xl underline"
                      : "text-[#a9a9a9] text-xl"
                  } font-semibold cursor-pointer`}
                  onClick={() => {
                    filteredResults(category.id);
                    setSelectedBrand(category.id);
                  }}
                >
                  {category.name}
                </li>
              ))}
          </ul>
        </div>
        <div className="grid grid-cols-3 gap-5 max-md:grid-cols-1">
          {products?.slice(0, 6).map((product, index) => (
            <Link
              to={`/urunler/urun-detay/${product.permalink}`}
              key={index}
              className="rounded-lg border border-gray-300  px-2 py-4 flex justify-center items-center group cursor-pointer"
            >
              <div className="flex-1 flex justify-center items-center">
                <img
                  alt={product.name}
                  src={`https://cdn.lensa.com.tr/${product?.images[0]?.photoUrl}`}
                  className="w-28 group-hover:w-32 transition-all duration-500"
                />
              </div>
              <div className="flex-1">
                <p className="font-bold text-xl mt-5">{product.name}</p>
                <ul className="mt-4 mb-4">
                  <li className="py-1">
                    Marka Adı:{" "}
                    <span className="font-semibold"> {product.brandName}</span>
                  </li>
                  <li className="py-1">
                    Kategori Adı:{" "}
                    <span className="font-semibold">
                      {product.categoryName}
                    </span>
                  </li>
                </ul>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div
        ref={(el) => (cardRefs.current[5] = el)}
        className="card-container container py-16"
      >
        <Slider {...settings}>
          {Referances.map((item, index) => (
            <div key={index} className="flex justify-center items-center">
              <img src={item} alt="" className="w-60" />
            </div>
          ))}
        </Slider>
      </div>
      <div className="container py-16">
        <h2 className="text-4xl mb-10">
          <span className="font-bold">EN ÇOK</span> ZİYARET EDİLENLER
        </h2>
        <div className="flex gap-10 max-md:flex-col">
          {products?.slice(3, 6).map((product, index) => (
            <Link
              key={product.id}
              to={`/urunler/urun-detay/${product.permalink}`}
              ref={
                index === 0
                  ? (el) => (cardRefs.current[6] = el)
                  : index === 1
                  ? (el) => (cardRefs.current[7] = el)
                  : (el) => (cardRefs.current[8] = el)
              }
              className="flex-1 card-container rounded-lg border border-gray-300  p-8 group cursor-pointer"
            >
              <div className="flex justify-center items-center h-52">
                <img
                  alt={product.name}
                  src={`https://cdn.lensa.com.tr/${product?.images[0]?.photoUrl}`}
                  className="w-40 group-hover:w-40 transition-all duration-500"
                />
              </div>
              <div className="mt-8">
                <p className="text-[#9a9a9a] font-bold py-2">
                  {product.categoryName}
                </p>
                <p className="font-semibold text-xl py-2">{product.name}</p>
                <p className="border-b inline-block text-lg py-1 mt-2">
                  İNCELE
                </p>
              </div>
            </Link>
          ))}

          <div
            ref={(el) => (cardRefs.current[10] = el)}
            className="flex-1 card-container flex flex-col gap-5 max-md:hidden"
          >
            <div className="relative flex-1 rounded-sm cursor-pointer">
              <img
                src={Bg1}
                className="w-full h-full  absolute top-0 left-0 rounded-sm"
                alt="Bg1"
              />
            </div>
            <div className="relative flex-1 rounded-sm flex justify-center items-center">
              <img
                src={Bg2}
                className="w-full h-full  absolute top-0 left-0 rounded-sm"
                alt="Bg2"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="container py-8 border-t card-container"
        ref={(el) => (cardRefs.current[11] = el)}
      >
        <div className="flex items-center justify-between gap-5 max-md:flex-col max-md:gap-10 max-md:items-start">
          <div className="flex-1 flex items-center gap-4">
            <img src={Shipped} className="w-10" />
            <div>
              <p className="font-bold text-lg">HIZLI TEDARİK</p>
              <p className="text-[#a9a9a9]">
                Ürünlerinizi aynı gün içinde kargoya vererek hızlı tedarik
                imkanını sağlıyoruz.
              </p>
            </div>
          </div>
          <div className="flex-1 flex items-center gap-4">
            <img src={CreditCard} className="w-10" />
            <div>
              <p className="font-bold text-lg">GENİŞ ÖDEME SEÇENEĞİ</p>
              <p className="text-[#a9a9a9]">
                Taksit Seçeneklerimiz ile ödemelerinizi çok daha geniş
                seçeneklerle yapın.
              </p>
            </div>
          </div>
          <div className="flex-1 flex items-center gap-4">
            <img src={CustomerService} className="w-10" />
            <div>
              <p className="font-bold text-lg">7/24 DESTEK</p>
              <p className="text-[#a9a9a9]">
                7/24 destek hattımız ile sorularınıza anında cevap veriyoruz.
              </p>
            </div>
          </div>

          <div className="flex-1 flex items-center gap-4">
            <img src={GuaranteeCertificate} className="w-10" />
            <div>
              <p className="font-bold text-lg">GARANTİ SÜRECİ</p>
              <p className="text-[#a9a9a9]">
                Garanti süreci ile beraber ürünlerinizde oluşabilecek sorunlara
                çözüm oluşturuyoruz.
              </p>
            </div>
          </div>

          <div className="flex-1 flex items-center gap-4">
            <img src={CustomerSupport} className="w-10" />
            <div>
              <p className="font-bold text-lg">TEKNİK SERVİS</p>
              <p className="text-[#a9a9a9]">
                Uzman teknik ekibimizle beraber cihazlarınızın sorunlarını
                hızlıca çözerek kullanılabilirliğini sağlıyoruz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
